<template>
  <div class="input-container" :class="{error : error }">
    <label :for="id">
      <slot />
      <transition name="showErrorIcon">
        <icon v-if="error" size="small" icon="error" />
      </transition>
    </label>
    <textarea
      :id="id"
      :value="value"
      :maxLength="maxLength"
      :placeholder="placeholder"
      @input="onInput"
    />

    <div class="feedback">
      <p class="form-control-feedback">
        <slot name="feedback" />
      </p>
      <p class="form-control-info">
        <slot name="info" />
      </p>
      <template v-if="showCharactersLeft">
        <p class="characters-left">{{ charactersLeftString }}</p>
      </template>
    </div>

  </div>
</template>

<script>
import { v4 as uuid } from 'uuid'

export default {
  props: {
    value: {
      type: String,
      required: false,
      default: ''
    },
    placeholder: {
      type: String,
      default: '',
      required: false
    },
    maxLength: {
      type: Number,
      required: false
    },
    showCharactersLeft: {
      type: Boolean,
      required: false,
      default: true
    },
    error: {
      type: Boolean,
      required: false
    }
  },
  methods: {
    onInput (e) {
      this.$emit('input', e.target.value)
    }
  },
  data () {
    return {
      id: null
    }
  },
  computed: {
    charactersLeftString () {
      return this.$t('CHARACTERS_REMAINING_LABEL', { characters: this.charactersLeft })
    },
    charactersLeft () {
      return this.value ? this.maxLength - this.value.length : this.maxLength
    }
  },
  mounted () {
    this.id = `textarea-${uuid()}`
  }
}
</script>

<style lang="scss" scoped>

  .input-container {
    display: flex;
    flex-direction: column;
  }

  textarea {
    min-width: 100%;
    max-width: 100%;
    min-height: $d-huge;
    outline: none;
    border: none;
  }

  .characters-left {
    text-align: right;
    color: $color-gray;
    margin-top: $space-030;
  }

  label {
    @include font('040');
    display: block;
    text-transform: none;
    color: $color-black;
    margin-bottom: $d-xx-small;
  }

  textarea {
    @include label-med;
    @include transition-fast;
    background-color: rgba($color-white, 0);
    border-radius: 2px 2px 0 0;
    outline-offset: 4px;
    padding: $d-small;
    line-height: 1.6;
    border-bottom: $line-medium;

    &:active {
      border-bottom: $line-dark;
      padding-top: $d-small;
    }

    &:focus {
      padding: $d-small;
      box-shadow: inset 0 -3px 0 $color-cream;
      background-color: $color-cream-light;

      &::placeholder {
        color: $color-gray;
      }
    }
  }

  .characters-left {
    @include body-sml;
  }

  .feedback > p {
    overflow: visible;
    height: 0;
  }

  .form-control-feedback, .form-control-info {
    @include body-sml;
    padding-top: 0;
  }

</style>
